export class EligibilityCalcRequest{
    partitionKey:string;
    payerId:string

    constructor(partitionKey:string, payerId:string){
        this.partitionKey = partitionKey;
        this.payerId = payerId;
    }
}